import * as yup from "yup"
import { AnyObject, string, StringSchema } from "yup"
import { MESSAGE_ERREUR_CONFIRMATION_EMAIL_FORMAT, MESSAGE_ERREUR_CONFIRMATION_EMAIL_NON_CORRESPONDANT, MESSAGE_ERREUR_CONFIRMATION_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_EMAIL_FORMAT, MESSAGE_ERREUR_EMAIL_OBLIGATOIRE, MESSAGE_ERREUR_EMAILNEW_EMAIL_IDENTIQUES } from "../../data/message-erreurs-form" 

export const RegExEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]{2,}\.[a-z]{2,4}$/;

export const emailSchemaRequired = (message: string): StringSchema<string, AnyObject, undefined> => string()
    .transform((value) => value ? value : undefined)
  .matches(RegExEmail, MESSAGE_ERREUR_EMAIL_FORMAT)
  .required(message);

  export const EmailSchema = yup.object().shape({
    EmailActuel: yup.string()
      .matches(RegExEmail, MESSAGE_ERREUR_EMAIL_FORMAT)
      .required(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE),
    NouveauEmail: yup.string()
      .required(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_EMAIL_OBLIGATOIRE)
      .notOneOf([yup.ref("EmailActuel"), null], MESSAGE_ERREUR_EMAILNEW_EMAIL_IDENTIQUES)
      .matches(RegExEmail, MESSAGE_ERREUR_EMAIL_FORMAT),
    ConfirmationEmail: yup.string().nullable()
      .required(MESSAGE_ERREUR_CONFIRMATION_EMAIL_OBLIGATOIRE)
      .oneOf([yup.ref("NouveauEmail")], MESSAGE_ERREUR_CONFIRMATION_EMAIL_NON_CORRESPONDANT)
      .typeError(MESSAGE_ERREUR_CONFIRMATION_EMAIL_OBLIGATOIRE)
      .matches(RegExEmail, MESSAGE_ERREUR_CONFIRMATION_EMAIL_FORMAT)
  });
  
